




















import Vue from 'vue';
import AceEditor from './editor/ace.vue';
import DataSourceCfg from './dataSourceCfg.vue';
import DataSourceDisplay from './dataSourceDisplay.vue';
export default Vue.extend({
    name: 'DataSource',
    data() {
        return {
            editor: {
                height: 400,
                width: 300,
                readOnly: true, 
            },
        }
    },
    components: {
        AceEditor,
        DataSourceCfg,
        DataSourceDisplay
    },
    methods: {
    },
    created() {
    },
    mounted() {
    }
})
